import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

class PurchaseButton extends Component {

  handleClick(event) {
    event.preventDefault();
    this.props.store.purchaseTickets();
  }     
  
  render() {
    const { store } = this.props;
    const spinnerUrl = 'https://my.kabbalah.com/ticket-widget/media/spinner.svg';
    const disabled = store.isCartEmpty() || store.processingPurchase.get();
    return (
      <button
        type="button" 
        className={'btn btn-block ' + (disabled ? 'btn-outline-danger' : 'btn-danger')}
        disabled={disabled}
        onClick={this.handleClick.bind(this)}
      >          
        Purchase
        {store.processingPurchase.get() && 
          <span>
            &nbsp;
            <img src={spinnerUrl} width="25px" alt="Loading..." />
          </span>
        }
      </button>        
    );
  }

}

export default inject('store')(observer(PurchaseButton));



// WEBPACK FOOTER //
// ./src/components/PurchaseButton.js